import React from "react";
import './use-case-features.css'

// ...... images .......
import interactive from '../../../../assets/images/intractive-purple.svg';
import insert from '../../../../assets/images/insert-call.svg';
import embed from '../../../../assets/images/embed-enywhere.svg';
import code from '../../../../assets/images/no-code.svg';

function UseCaseFeatures() {
   return(
       <div className="content-box width-1000">
          <div className="title-font">Top Features</div>
          <ul className="features-list col-2">
             <li>
                <div className="icon feature-icon">
                   <img src={interactive} alt=""/>
                </div>
                <div className="feature-title rubik-medium">Content Library</div>
                <div className="feature-desc">
                   Create, update and maintain all the process documentation in one place.
                </div>
             </li>
             <li>
                <div className="icon feature-icon">
                   <img src={insert} alt=""/>
                </div>
                <div className="feature-title rubik-medium">Effortless Integration</div>
                <div className="feature-desc">
                   Integrates easily with most tools, wikis and knowledge bases
                </div>
             </li>
             <li>
                <div className="icon feature-icon">
                   <img src={embed} alt=""/>
                </div>
                <div className="feature-title rubik-medium">Browser extension</div>
                <div className="feature-desc">
                   Works on any web product or web-based workflow
                </div>
             </li>
             <li>
                <div className="icon feature-icon">
                   <img src={code} alt=""/>
                </div>
                <div className="feature-title rubik-medium">Engagement Insights</div>
                <div className="feature-desc">
                   Enhanced analytics on views, watch time, CTA clicks
                </div>
             </li>
          </ul>
       </div>
   )
}

export default UseCaseFeatures
